import * as React from 'react';

interface IPhotoFrameProps {
  image: Record<string, any>;
  imageSrc: string;
}

export const PhotoFrame = ({ image, imageSrc }: IPhotoFrameProps) => {
  return (
    <div
      style={{
        height: `${image.height}mm`,
        left: `${image.left}mm`,
        lineHeight: `${image.lineHeight}mm`,
        position: 'absolute',
        top: `${image.top}mm`,
        transform: `rotateZ(${image.rotation}deg)`,
        width: `${image.width}mm`,
        zIndex: 5,
      }}
    >
      <img
        src={image.image.smallUrl}
        alt="Image"
        style={{
          height: `100%`,
          left: `0`,
          position: 'absolute',
          top: `0`,
          transform: `rotateZ(${image.rotation}deg)`,
          width: `100%`,
          zIndex: 5,
        }}
      />
      <div
        style={{
          bottom: `${image.borderBottomWidth}mm`,
          left: `${image.borderLeftWidth}mm`,
          position: 'absolute',
          right: `${image.borderRightWidth}mm`,
          top: `${image.borderTopWidth}mm`,
          transform: `rotateZ(${image.rotation}deg)`,
          zIndex: 4,
        }}
      >
        <img src={imageSrc} alt="Image" style={{ width: '100%', height: '100%' }} />
      </div>
    </div>
  );
};
